/**
 * Admin Icons
 *
 * Icons used by the mobile admin port (settings sub-tabs + top-level
 * tabs). Kept in their own file so the admin port can grow without
 * bloating core.icons.ts.
 *
 * NOTE on legacy aliases: several icons here use FA5-era names
 * (shield-alt, sliders-h, trash-alt, tachometer-alt, hands-helping,
 * exclamation-triangle, times-circle, sync) because that's what the
 * legacy admin web code uses verbatim. FA6 still ships these as
 * compatibility exports — keeping the names matches the legacy
 * source for easy 1:1 porting.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSync as fasSync,
  faTimesCircle as fasTimesCircle,
  // Note template schema builder field-type icons
  faInputText as fasInputText,
  faAlignLeft as fasAlignLeft,
  faToggleOn as fasToggleOn,
  faSquareCheck as fasSquareCheck,
  faSquareCaretDown as fasSquareCaretDown,
  faGripDotsVertical as fasGripDotsVertical,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faBoxArchive as fadBoxArchive,
  faBroom as fadBroom,
  faBug as fadBug,
  faBuilding as fadBuilding,
  faBuildingUser as fadBuildingUser,
  faBullseye as fadBullseye,
  faCode as fadCode,
  faCommentSms as fadCommentSms,
  faDatabase as fadDatabase,
  faEnvelopeOpen as fadEnvelopeOpen,
  faExclamationTriangle as fadExclamationTriangle,
  faFire as fadFire,
  faFlagUsa as fadFlagUsa,
  faForwardFast as fadForwardFast,
  faGears as fadGears,
  faGraduationCap as fadGraduationCap,
  faHandsHelping as fadHandsHelping,
  faMessageBot as fadMessageBot,
  faMonitorWaveform as fadMonitorWaveform,
  faPalette as fadPalette,
  faPenLine as fadPenLine,
  faShield as fadShield,
  faShieldAlt as fadShieldAlt,
  faStop as fadStop,
  faSlidersH as fadSlidersH,
  faTachometerAlt as fadTachometerAlt,
  faTags as fadTags,
  faTrashAlt as fadTrashAlt,
  faUserClock as fadUserClock,
  faWaveSine as fadWaveSine,
  faWaveformLines as fadWaveformLines,
  faWrench as fadWrench,
} from '@fortawesome/pro-duotone-svg-icons';

export const loadAdminIcons = () => {
  library.add(
    // Solid (fas)
    fasSync,
    fasTimesCircle,
    fasInputText,
    fasAlignLeft,
    fasToggleOn,
    fasSquareCheck,
    fasSquareCaretDown,
    fasGripDotsVertical,

    // Duotone (fad)
    fadBoxArchive,
    fadBroom,
    fadBug,
    fadBuilding,
    fadBuildingUser,
    fadBullseye,
    fadCode,
    fadCommentSms,
    fadDatabase,
    fadEnvelopeOpen,
    fadExclamationTriangle,
    fadFire,
    fadFlagUsa,
    fadForwardFast,
    fadGears,
    fadGraduationCap,
    fadHandsHelping,
    fadMessageBot,
    fadMonitorWaveform,
    fadPalette,
    fadPenLine,
    fadShield,
    fadShieldAlt,
    fadStop,
    fadSlidersH,
    fadTachometerAlt,
    fadTags,
    fadTrashAlt,
    fadUserClock,
    fadWaveSine,
    fadWaveformLines,
    fadWrench,
  );
};
